

export const ApiForImage = "https://alnada-ekramapi.azurewebsites.net/";
// export const ApiForImage = "https://alnada-devekram.azurewebsites.net/";
export const PasswordPattern = '(?=.*[A-Za-z])(?=.*[0-9])(?=.*[$@$!#^~%*?&,.<>"\'\\;:\{\\\}\\\[\\\]\\\|\\\+\\\-\\\=\\\_\\\)\\\(\\\)\\\`\\\/\\\\\\]])[A-Za-z0-9\d$@].{6,}';